import type { WorksheetSequenceMetaV2, WorksheetSurfaceProfileV2 } from './worksheetTypes';

export const WORKSHEET_SURFACE_PROFILE_V2: WorksheetSurfaceProfileV2 = {
  version: 1,
  layout: 'WORKSHEET_FIRST',
  problemsPerPage: 5,
  sequenceSupport: 'FADE_BY_FROZEN_ORDER',
};

/**
 * Student-safe surface metadata. It is derived only from frozen presentation
 * order and never from answer correctness, answer keys, or hidden solutions.
 */
export function deriveWorksheetSequenceMetaV2(index: number, total: number): WorksheetSequenceMetaV2 {
  if (!Number.isInteger(index) || index < 0 || !Number.isInteger(total) || total <= 0 || index >= total) {
    throw new Error('Worksheet sequence metadata requires a valid frozen index/total pair.');
  }
  const ordinal = index + 1;
  const supportedCutoff = Math.max(1, Math.ceil(total * 0.2));
  const fadingCutoff = Math.max(supportedCutoff + 1, Math.ceil(total * 0.5));
  if (ordinal <= supportedCutoff) return { ordinal, total, phase: 'SUPPORTED', surfaceSupport: 'FULL' };
  if (ordinal <= fadingCutoff) return { ordinal, total, phase: 'FADING', surfaceSupport: 'LIGHT' };
  return { ordinal, total, phase: 'INDEPENDENT', surfaceSupport: 'MINIMAL' };
}
